import { render, staticRenderFns } from "./CopyLink.vue?vue&type=template&id=4c215094"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c215094')) {
      api.createRecord('4c215094', component.options)
    } else {
      api.reload('4c215094', component.options)
    }
    module.hot.accept("./CopyLink.vue?vue&type=template&id=4c215094", function () {
      api.rerender('4c215094', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/CopyLink.vue"
export default component.exports